import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axiosClient from '../api/AxiosConfig';

export default function useFindUser() {
  const [user, setUser] = useState(null);
  const [isLoading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    async function findUser() {
      await axiosClient
        .get('/get-me')
        .then((res) => {
          setUser(res.data);
          setLoading(false);
        })
        .catch((err) => {
          setUser(null);
          navigate('/login', { replace: true });
          setLoading(false);
        });
    }

    findUser();
  }, []);

  return {
    user,
    setUser,
    isLoading,
  };
}
